export class StrategyCopyConstants {
  static ALREADY_IN_A_STRATEGY =
    'This contact is already enrolled in the sequence';
  static notOwnedAndEnrolledMessage = (owner: string | null) =>
    `This contact is owned by ${owner ?? 'deleted user'} and is already enrolled in a sequence.`;

  static NOT_ALLOWED_TO_ENROLL_DUE_TO_OWNERSHIP =
    'You can’t enroll in a sequence if you’re not the owner or a manager';
  static NOT_ALLOWED_TO_ENROLL_DUE_TO_DELETED_COMPANY = 'Missing company';

  static STOP_INSTANCE_TEXT = 'Stop sequence';
  static ADD_TO_STRATEGY_TEXT = 'Add to sequence';
  static RESUME_INSTANCE_TEXT = 'Resume sequence';

  static STOPPED_INSTANCE_TEXT = 'Sequence stopped';
  static COMPLETED_INSTANCE_TEXT = 'Sequence completed';
}
